/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// utils
import transpileEmbedSettings from 'utils/embeds/transpilers/embedsettings/transpiler';
import transpileContentData from 'utils/embeds/transpilers/contentdata/transpiler';
import { pqContentData } from 'utils/embeds/pqContentData';
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embediframe/embediframe_styles';



/* ========== ~~~~~~~~~~ EMBED IFRAME : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EmbedIFrame extends Component {
    constructor(props) {
        super(props);
        this.iframeEl = null;
    }
    componentDidMount() {
        // set iframe styles
        this.iframeEl.frameBorder = "0";
        this.iframeEl.scrolling = "no";
        this.iframeEl.marginheight = "0";
        this.iframeEl.marginwidth = "0";
        this.iframeEl.topmargin = "0";
        this.iframeEl.leftmargin = "0";
        this.iframeEl.allowtransparency = "true";
        const contentData = transpileContentData(this.props.contentStatus);
        // append objects and functions to iframe window (embed application will read from and utilize these to build itself)
        this.iframeEl.contentWindow.embedSettings = transpileEmbedSettings(this.props.selectedEmbedStatus.selectedEmbedData, this.props.contentStatus);
        this.iframeEl.contentWindow.getEmbedSettings = function() { return this.embedSettings };

        this.iframeEl.contentWindow.mxQuestionData = contentData.mxQuestionData;
        this.iframeEl.contentWindow.getMxQuestionData = function() { return JSON.parse(this.mxQuestionData) };

        this.iframeEl.contentWindow.mxResultData = contentData.mxResultData;
        this.iframeEl.contentWindow.getMxResultData = function() { return JSON.parse(this.mxResultData) };

        this.iframeEl.contentWindow.pqQuestionData = pqContentData;
        this.iframeEl.contentWindow.getPqQuestionData = function() { return this.pqQuestionData };
        // create div inside iframe
        const div = document.createElement("div");
        div.id = "app";
        // create script inside iframe head that will load embed application into div
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url.embedSrc;
        // We have to timeout appending embed script and div to the head and the body of the iframe to solve a known Firefox specific issue.
        // More info: https://stackoverflow.com/questions/3255702/firefox-strange-behaviour-when-working-with-javascript-on-an-iframe
        window.setTimeout(() => {
            this.iframeEl.contentWindow.document.body.appendChild(div);
            this.iframeEl.contentWindow.document.head.appendChild(script);
        },100);
    };
    render() {
        const embedLocation = this.props.location;
        return (
            <div className={`embediframe ${this.props.classes.embediframe}`}>
                <div id="insticator-container">
                    <div id="div-insticator-ad-1" className={`${embedLocation === 'rail' ? 'rail' : null}`}>
                        <div className={`desc`}>Ad 1</div>
                    </div>
                    <div id="insticator-embed" className={embedLocation === 'rail' ? 'rail' : null} >
                        <iframe id="insticator-iframe" title={`Preview Embed`} className={`embedcontainer  `} ref={input => this.iframeEl = input} />
                    </div>
                    <div id="div-insticator-ad-2" className={`${embedLocation === 'rail' ? 'rail' : null}`}>
                        <div className={`desc`}>Ad 2</div>
                    </div>
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmbedIFrame);
